<template>
  <router-view />

  <!-- 数字助手悬浮窗 - 无人机学习系统页面不显示 -->
  <div v-if="!isDronePage" class="digital-assistant-wrapper">
    <DigitalAssistant />
  </div>

  <!-- 无人机图片 - 无人机学习系统页面不显示 -->
  <!-- <div v-if="!isDronePage" class="drone-image-container">
    <img
      :src="bannerImage"
      alt="全国青少年国防素养大赛智能无人系统应用赛线上答题系统"
      class="drone-image"
      @load="onImageLoad"
      @error="onImageError"
      @click="goToDroneStudy"
      style="display: block; cursor: pointer"
    />
    <div v-if="imageLoading" class="loading-indicator">图片加载中...</div>
    <div v-if="imageError" class="error-message">图片加载失败</div>
  </div> -->

  <!-- 登录弹窗 -->
  <LoginRegisterDialog ref="loginDialog" />
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import bannerImage from "@/assets/无人机.jpg";
import { useAuthStore } from "@/store/authStore";
import DigitalAssistant from "@/components/DigitalAssistant.vue";
import LoginRegisterDialog from "@/components/LoginRegisterDialog.vue";
import { useHead } from "@unhead/vue";

const router = useRouter();
const route = useRoute();
const imageLoading = ref(true);
const imageError = ref(false);
const loginDialog = ref(null);

// 判断当前是否在无人机学习系统页面
const isDronePage = computed(() => {
  return route.path.startsWith("/drone");
});

const onImageLoad = () => {
  imageLoading.value = false;
  imageError.value = false;
  console.log("宣传图片加载成功");
};

const onImageError = (e) => {
  imageLoading.value = false;
  imageError.value = true;
  console.error("宣传图片加载失败", e);
};

const goToDroneStudy = () => {
  console.log("goToDroneStudy called");
  const authStore = useAuthStore();
  console.log("登录状态:", authStore.isAuthenticated);
  if (authStore.isAuthenticated) {
    router.push("/drone");
  } else {
    if (loginDialog.value) {
      loginDialog.value.openDialog();
    }
  }
};

// 全站通用TDK模板，只需要替换【网站名称】即可切换站点
useHead({
  // 网页标题Title
  //titleTemplate: "%s - 专业军校报考招生信息平台",
  // 默认首页标题
  title: "砺兵军招升学规划网",
  meta: [
    {
      name: "description",
      content:
        "专注全国军校招生政策解读、报考条件、录取分数线、体检政审标准、志愿填报指导，为考生及家长提供权威合规的军校升学服务。",
    },
    {
      name: "keywords",
      content: "砺兵教育，军校报考，军校招生，军校分数线，军校体检，志愿填报",
    },
  ],
});
</script>

<style>
/* 全局样式重置 */
body {
  margin: 0;
}

/* 数字助手样式 */
.digital-assistant-wrapper {
  position: fixed;
  top: 120px;
  right: 30px;
  z-index: 9999;
}

.digital-assistant-wrapper :deep(.digital-assistant) {
  position: relative !important;
}

/* 无人机图片容器 */
.drone-image-container {
  position: fixed;
  right: 8px;
  top: 300px;
  width: 190px;
  height: 330px;
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  pointer-events: none;
  animation: float-slow 4s ease-in-out infinite;
}

@keyframes float-slow {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-8px) rotate(1deg);
  }
}

.drone-image-container .drone-image {
  width: 100%;
  height: 100%;
  pointer-events: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.drone-image-container .drone-image:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 24px rgba(76, 138, 255, 0.4);
}

.loading-indicator,
.error-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #666;
  font-size: 12px;
}

/* 响应式样式 */
@media (max-width: 768px) {
  .drone-image-container {
    width: 140px;
    height: 240px;
    top: 220px;
    right: 5px;
  }

  .digital-assistant-wrapper {
    top: 150px;
    right: 12px;
  }
}

@media (max-width: 480px) {
  .drone-image-container {
    width: 110px;
    height: 190px;
    top: 190px;
    right: 5px;
  }

  .drone-image-container .drone-image {
    border-radius: 3px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }

  .digital-assistant-wrapper {
    top: 120px;
    right: 8px;
  }
}
</style>
